import { readable } from "svelte/store";

const businesses = readable(window.businesses);

export default businesses;
